<template>
  <div style="width: 100%; height: 100%">
    <!-- 礼包中心弹窗 -->
    <GiftDialog ref="dialog" @refreshDetails="refreshDetails"></GiftDialog>
    <div :class="$style.box">
      <TopHeader headerTitle="礼包说明" :isShowMenuIcon="false" />
      <section :class="$style['gift-bar']">
        <img :src="giftInfo.icon" />
        <div>
          <p>
            {{ giftInfo.title }}
            <img v-if="giftInfo.type === 1" :src="vipIcon" width="21px" />
            <img v-else :src="commonIcon" width="21px" />
          </p>
          <!-- <p>失效时间：{{ formatDate(giftInfo.end_time) }}</p> -->
        </div>
        <button v-if="giftInfo.can_get" @click="handleReceiveGift(giftInfo)">领取</button>
        <button v-else style="background-color: #9d9d9d" @click="alreadyReceivedGift">
          已领取
        </button>
      </section>
      <CircleBaseBox v-if="claimTimes" boxTitle="领取时间" :class="$style.times">
        <div :class="$style.timeRange">{{ claimTimes }}</div>
      </CircleBaseBox>
      <CircleBaseBox boxTitle="礼包详情" :class="$style.detail">
        <pre :class="$style.content" v-html="giftInfo.gift_explain"></pre>
      </CircleBaseBox>
      <CircleBaseBox boxTitle="温馨提示">
        <div :class="$style.tips">
          {{
            `1. 领取礼包需先绑定游戏账号 
          2. 领取礼包后，请记录礼包码，自行前往游戏中兑换 
          3. 可在“我的礼包”中查看已领取的礼包码 
          4. 每种礼包有数量和兑换时间限制，请及时获取并兑换 
          5. 礼包具体奖励以游戏内实际兑换为准 
          6. 官方保留最终解释权`
          }}
        </div>
      </CircleBaseBox>
    </div>
  </div>
</template>

<script>
import GiftDialog from './components/GiftDialog';
import TopHeader from '_c/TopHeader';
import CircleBaseBox from '_c/CircleBaseBox';
import { mapMutations, mapActions } from 'vuex';
import { getGiftDetail } from '@/api/giftCenter';
import { reportData } from '@/api/report';
import { CDN_URL } from '@/config/index.js';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      commonIcon: `${CDN_URL}/gift_center/all.png`,
      vipIcon: `${CDN_URL}/gift_center/VIP.png`,
      giftInfo: {},
    };
  },
  components: {
    TopHeader,
    GiftDialog,
    CircleBaseBox,
  },
  created() {
    reportData({
      type: 10,
      data_type: 5,
      gift_set_id: this.$route.query.giftId,
    });
    this.getGiftDetail();
  },
  computed: {
    claimTimes() {
      if (!this.giftInfo.show_time || this.giftInfo.show_time.length === 0) return '';

      let res = '';

      this.giftInfo.show_time.forEach((m) => {
        res += `${m.start_time} - ${m.end_time}\n`;
      });

      return res;
    },
  },
  methods: {
    ...mapMutations('giftCenter', {
      SHOW_GIFT_DIALOG: 'SHOW_GIFT_DIALOG',
      SET_GIFT_ITEM: 'SET_GIFT_ITEM',
    }),
    // 获取礼包详情
    async getGiftDetail() {
      const r = await getGiftDetail({ gift_set_id: this.$route.query.giftId });
      this.giftInfo = { ...r.data };
    },
    // 打开领取礼包弹窗
    handleReceiveGift(item) {
      this.SHOW_GIFT_DIALOG(true);
      this.SET_GIFT_ITEM(item);
    },
    // 点击已领取按钮
    alreadyReceivedGift() {
      this.$refs.dialog.showNormalDialog('receivedGift');
    },
    refreshDetails() {
      this.getGiftDetail();
    },
    formatDate(date) {
      return dayjs(date).format('YYYY年MM月D日');
    },
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
@import '~@/styles/variable.scss';
.box {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: #efefef;
  .gift-bar {
    margin: auto;
    margin-top: 7px;
    padding: 10px 11px 11px 17px;
    width: 361px;
    height: 65px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.03);
    border-radius: 7px;
    display: flex;
    align-items: center;
    > img {
      width: 45px;
      margin-right: 5px;
      border-radius: 12px;
    }
    div:nth-child(2) {
      width: 218px;
      line-height: 12px;
      p:first-child {
        margin-bottom: 7.5px;
        font-size: 11px;
        span {
          margin-left: 1px;
          padding: 0px 4px 0px 2px;
          font-size: 7.5px;
          color: #fff;
          background-color: #70cbff;
          border-radius: 4px;
        }
      }
      p:last-of-type {
        @include ellipsis(1);
        font-size: 10px;
        color: #9f9f9f;
      }
    }
    button {
      @include clearBtnDefaultStyle;
      padding: 0;
      margin-left: 10px;
      width: $buttonWidth;
      height: $buttonHeight;
      color: #fff;
      font-size: 10px;
      background-color: $buttonColor;
      border-radius: 15px;
    }
  }
  .detail {
    margin-top: 7px;
    height: 200px;
    .content {
      width: 100%;
      padding: 5px 7px 7px 7px;
      font-size: 12px;
      line-height: 23px;
      color: #9f9f9f;
      white-space: pre-wrap; /* css-3 */
      white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
      white-space: -pre-wrap; /* Opera 4-6 */
      white-space: -o-pre-wrap; /* Opera 7 */
      word-wrap: break-word; /* Internet Explorer 5.5+ */
      overflow: auto;
      word-break: break-all;
      word-wrap: break-word;
    }
  }
  .tips {
    margin-top: -12px;
    margin-left: 8px;
    height: 160px;
    font-size: 11px;
    line-height: 18px;
    white-space: pre-line;
    color: #9f9f9f;
    white-space: pre-line;
  }
  .times {
    margin-top: 7px;
    min-height: 50px;
    .timeRange {
      margin-left: 8px;
      font-size: 11px;
      line-height: 18px;
      white-space: pre-line;
      color: #9f9f9f;
      white-space: pre-line;
    }
  }
}
</style>
